module.exports = __webpack_public_path__ + "img/title.e71ee053.png";